// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"53071a6c","425":"7f3c7e3a","453":"89ed03ae"}[chunkId] + ".chunk.js";
};